import React, { createContext, useContext, useMemo, useState } from "react";
import DialogBox from "~/presentation/components/DialogBox";

export const DialogContext = createContext();
export const useDialog = () => useContext(DialogContext);

export const DialogProvider = ({ children }) => {
  const initialDialog = { open: false };
  const [dialog1, setDialog1] = useState(initialDialog);
  const [dialog2, setDialog2] = useState(initialDialog);
  const [dialog3, setDialog3] = useState(initialDialog);
  const [loginDialog, setLoginDialog] = useState(initialDialog); //só para o login (ficar sempre no topo)

  // message, callback(), negativeCallback(), confirmText, denyText, customComponent,
  const customHandleClose = (callback) => {
    return callback.onClose ? callback.onClose() : null;
  };

  const openDialog = (props) => setDialog1({ open: true, ...props });
  const closeDialog = () => {
    customHandleClose(dialog1);
    setDialog1(initialDialog);
  };

  const openSecondDialog = (props) => setDialog2({ open: true, ...props });
  const closeSecondDialog = () => setDialog2(initialDialog);

  const openThirdDialog = (props) => setDialog3({ open: true, ...props });
  const closeThirdDialog = () => setDialog3(initialDialog);

  const openLoginDialog = (props) => setLoginDialog({ open: true, ...props });
  const closeLoginDialog = () => setLoginDialog(initialDialog);

  const value = {
    openDialog,
    closeDialog,
    openSecondDialog,
    closeSecondDialog,
    openThirdDialog,
    closeThirdDialog,
    openLoginDialog,
    closeLoginDialog,
  };

  return (
    <DialogContext.Provider value={useMemo(() => value, [])}>
      {children}
      <DialogBox config={dialog1} onClose={closeDialog} />
      <DialogBox config={dialog2} onClose={closeSecondDialog} />
      <DialogBox config={dialog3} onClose={closeThirdDialog} />
      <DialogBox config={loginDialog} onClose={closeLoginDialog} />
    </DialogContext.Provider>
  );
};
